import { Box, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import TableRowSkeleton from "../../components/skeletons/TableRowSkeleton";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import {
  GetAllCustomerInfoFilter,
  GetAllCustomerInfoResponse,
} from "../../models/customer.model";
import { PaginationInfo } from "../../models/security.model";
import {
  GetAllCustomerInfo,
  GetAllCustomerInfoExcel,
} from "../../services/customer.service";
import CustormerInfoListFilters from "./components/CustormerInfoListFilters";
import CustormerInfoTable from "./components/CustormerInfoTable";

const CustomerInfoList = () => {
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [showFilter, setShowFilter] = useState(true);
  const [customerInfoList, setCustomerInfoList] = useState<
    GetAllCustomerInfoResponse[]
  >([]);
  const [filterObject, setFilterObject] = useState<GetAllCustomerInfoFilter>();

  // service calls
  const { mutate: GetAllCustomerInfoMutate, isLoading } = useMutation(
    GetAllCustomerInfo,
    {
      onSuccess: (data: ApiResultModel<GetAllCustomerInfoResponse[]>) => {
        if (data) {
          setCustomerInfoList(data.data);
          setPageInfo(data.pageInfo);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetAllCustomerInfoExcelMutate } = useMutation(
    GetAllCustomerInfoExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );

  //handlers
  const handleClick = (id: number) => {
    localStorage.setItem("CUSTOMER_ID", String(id));
    const newWindow = window.open("/#/CustomerInfoDetail", "_blank");
    newWindow?.history.pushState(
      {
        state: { customerId: id },
      },
      "",
      "/CustomerInfoDetail"
    );
  };
  const handleExportExcel = () => {
    GetAllCustomerInfoExcelMutate({
      ...filterObject!,
    });
  };

  useEffect(() => {
    GetAllCustomerInfoMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter && (
          <Grid item xs={12} sx={{ marginBottom: "20px" }}>
            <CustormerInfoListFilters
              filterObject={filterObject!}
              setFilterObject={setFilterObject}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          {!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <CustormerInfoTable
                customerInfoList={customerInfoList}
                pageInfo={pageInfo}
                currentPaginationInfo={currentPaginationInfo}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
                handleClick={handleClick}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableRowSkeleton rowsNum={10} columnsNum={12} />
            </span>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomerInfoList;
